import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';

const SearchInput = ({ placeholder, className, onSearch }) => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

   const handleSearch = () => {
    if (query.trim()) {
      navigate(`/search?query=${encodeURIComponent(query.trim())}`);
      if (onSearch) onSearch(); // ВАЖНО! Закрываем Offcanvas!
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <InputGroup>
      <Form.Control
        value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder={placeholder}
                aria-label="Search"
                aria-describedby="basic-addon2"
                className={className}
                
      />
      <InputGroup.Text
                id="basic-addon2"
                style={{ cursor: 'pointer' }}
                onClick={handleSearch}
            >
                <Search />
            </InputGroup.Text>
        </InputGroup>
  );
};

export default SearchInput;

/*
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, InputGroup, Button } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';

const SearchInput = ({ placeholder, className }) => {
  const [query, setQuery] = useState('');
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault(); // не даём форме перезагрузить страницу
    if (query.trim()) {
      navigate(`/search?query=${encodeURIComponent(query.trim())}`);
    }
  };

  return (
    <Form onSubmit={handleSearch}>
      <InputGroup>
        <Form.Control
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder={placeholder}
          aria-label="Search"
          className={className}
        />
        <Button variant="outline-secondary" type="submit">
          <Search />
        </Button>
      </InputGroup>
    </Form>
  );
};

export default SearchInput;
*/